module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-packet"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card-n', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 8
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('packet-buttons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v("P" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v("Name")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v("Amount")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v(_vm._s(_vm.item.amount))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_vm._v("Minutes")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_vm._v(_vm._s(_vm.item.minutes))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_vm._v("Distance")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_vm._v(_vm._s(_vm.item.distance))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n6"
    },
    slot: "n6"
  }, [_vm._v("Duration")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n6"
    },
    slot: "n6"
  }, [_vm._v(_vm._s(_vm.item.duration))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n7"
    },
    slot: "n7"
  }, [_vm._v("Max Uses")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n7"
    },
    slot: "n7"
  }, [_vm._v(_vm._s(_vm.item.max_uses))]), _c('div', {
    staticClass: "label",
    attrs: {
      "slot": "n8"
    },
    slot: "n8"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n8"
    },
    slot: "n8"
  }, [_vm._v(_vm._s(_vm.item.status))])])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20d30b82!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Packet.vue
// module id = 2331
// module chunks = 1